import ModalSentErrorWithInfo from './ModalSentErrorWithInfo/ModalSentErrorWithInfo';
import React, { useCallback, useContext } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../firmwareState/firmwareContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';

export const ModalWindows: React.FC = () => {
	const {
		showErrorModalWithInfo,
		changeTypeOfModalWindow,
		deleteSelectedItem,
		errorResponseData,
		typeOfModalWindow,
	} = useContext<IFirmwareContext>(FirmwareContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	const handleCloseModalWithInfo = useCallback(() => showErrorModalWithInfo(null), [showErrorModalWithInfo]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !!errorResponseData}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteFirmware"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteFirmwareSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingFirmware"
			/>
			<ModalSentErrorWithInfo
				onConsentEvent={handleCloseModalWithInfo}
				isVisible={!!errorResponseData}
				errorResponseData={errorResponseData}
			/>
		</ModalWrapper>
	);
};
